import * as React from 'react';
import {cn} from '../lib/cn';

export interface ButtonsGroupLabelProps extends React.PropsWithChildren {
  label: string;
  className?: string;
}

export function ButtonsGroupLabel({children, label, className}: ButtonsGroupLabelProps) {
  return (
    <div data-slot="buttons-group-label" className={cn(className)}>
      <div className="mb-2 text-xs font-medium text-[var(--chekin-color-gray-1)]">
        {label}
      </div>
      <div>{children}</div>
    </div>
  );
}

ButtonsGroupLabel.displayName = 'ButtonsGroupLabel';
